import React, { Component } from 'react';
import { connect } from 'react-redux';
import { errorAction } from '../../../reducers/actions';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // Log error
    try {
      // todo add info about child component to error\
      if (info && info.componentStack) {
        error.stack = info.componentStack;
      }
      this.props.errorAction(error, 'components/common/ErrorBoundary');
    } catch (e) { }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    errorAction() {
      dispatch(errorAction(...arguments));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/common/errorboundary/ErrorBoundary.js